export const mockAPIPath = {
    EDIT_MAINTENANCE:"./data/system-config-GET.json",
};

export const serverAPIPath = {
    EDIT_MAINTENANCE:"/master/system-config",
    POST_UNDER_MAINTENANCE:"/master/system-config"

};